import React from 'react';
import './scss/index.scss';
import RouteIndex from './routes/route-index';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <React.Fragment>
      <RouteIndex />
      <ToastContainer position="bottom-center" autoClose={3000} />
    </React.Fragment>
  );
}

export default App;